import axios from "axios";
// const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ENV_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL =
  ENV_BASE_URL === "https://api.dooritt.com/admin/api/v1"
    ? "https://api.oora.ai/api/v1"
    : "https://stag.oora.ai/api/v1";

const config = {
  headers: { "Content-Type": "application/json" },
};

// formData = { page: 1, limit: 10, search: "Sector 150" }
export const getOoraJobLogsList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_JOB_LOGS_LIST_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/oora-job-logs/list`, // check mount path
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_JOB_LOGS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_JOB_LOGS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_JOB_LOGS_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const getOoraJobLogsByJobId = (job_id, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_JOB_LOGS_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/oora-job-logs/get`, // check mount path
        { job_id },
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_JOB_LOGS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_JOB_LOGS_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_JOB_LOGS_FAIL", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};